/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

export function voteAndSubmit(value) {
  const npsOptions = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
  const hjContainer = document.getElementsByClassName(
    "_hj-widget-container"
  )[0];

  if (!hjContainer) return;
  const hjButtons = hjContainer.getElementsByTagName("button");
  const hjReplyButton = Array.from(hjButtons).filter(
    (b) => b.innerText === "Reply"
  )[0];
  if (hjReplyButton) hjReplyButton.click();

  setTimeout(() => {
    const hjButtons = hjContainer.getElementsByTagName("button");
    const npsButtons = Array.from(hjButtons).filter((b) =>
      npsOptions.includes(b.innerText)
    );
    const hjNextButton = Array.from(hjButtons).filter(
      (b) => b.innerText === "Next"
    )[0];

    if (npsButtons.length !== 11) return;
    const userIntention = npsButtons.find(
      (v) => v.innerText === value.toString()
    );

    if (!userIntention) return;
    userIntention.click();

    if (!hjNextButton) return;
    const clickNextButton = setInterval(() => {
      if (!hjNextButton.disabled) {
        hjNextButton.click();
        clearInterval(clickNextButton);
      }
    }, 1000);
  }, 1000);
}

export function isSurveyAvailable() {
  const hjContainer = document.getElementsByClassName(
    "_hj-widget-container"
  )[0];
  const npsSurvey = hjContainer
    ? hjContainer.querySelector('[role="dialog"]')
    : null;
  return npsSurvey ? true : false;
}

export function hideWidgetContainer() {
  if (document.getElementsByClassName("_hj-widget-container")[0]) {
    document.getElementsByClassName("_hj-widget-container")[0].style.display =
      "none";
    return true;
  }
  return false;
}
